import React from 'react';
import CompanyLink from '../../TabsComponent/CompanyLink';

const CompanyLinkPrint = ({ companyLinks, itemsToExport }) => {
  if (!itemsToExport.value) return <></>;

  return (
    <div className="mrg-top-30">
      <CompanyLink companyLinksData={companyLinks} />
    </div>
  );
};

export default CompanyLinkPrint;
